import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const cellValue = (column, row) => {
    const value = column.exportValue ? column.exportValue(row) : row?.[column.key];
    return value === null || value === undefined ? "" : String(value);
};

const exportableColumns = (columns) => columns.filter((column) => !column.noExport);

const escapeCSV = (value) => {
    if (/[",\r\n]/.test(value)) {
        return `"${value.replace(/"/g, '""')}"`;
    }
    return value;
};

export const exportCSV = (columns, rows, filename) => {
    const cols = exportableColumns(columns);
    const lines = [
        cols.map((column) => escapeCSV(column.label)).join(","),
        ...rows.map((row) => cols.map((column) => escapeCSV(cellValue(column, row))).join(",")),
    ];

    const blob = new Blob(["﻿" + lines.join("\r\n")], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

export const exportPDF = (title, columns, rows, filename) => {
    const cols = exportableColumns(columns);
    const doc = new jsPDF("landscape");

    doc.text(title, 14, 15);

    autoTable(doc, {
        head: [cols.map((column) => column.label)],
        body: rows.map((row) => cols.map((column) => cellValue(column, row))),
        startY: 20,
        styles: { fontSize: 8 },
        headStyles: {
            fillColor: [0, 41, 98],
            textColor: 255
        }
    });

    doc.save(filename);
};

// Numeric helpers shared by report column definitions
export const toNumber = (value) => {
    const num = parseFloat(value);
    return isNaN(num) ? 0 : num;
};

export const toFixed2 = (value) => toNumber(value).toFixed(2);
